import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=e88018a4&scoped=true&"
import script from "./sideBar.vue?vue&type=script&lang=ts&"
export * from "./sideBar.vue?vue&type=script&lang=ts&"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=e88018a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88018a4",
  null
  
)

component.options.__file = "sideBar.vue"
export default component.exports